export default __webpack_public_path__ + "static/media/s1.caa277d5.png";